// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3tpRmJIPd0SENdWdx7CC32"};